import { FormHandle } from '@/hooks/use-form-handle.hook';
import { FC } from 'react';
import InputControl from '@/components/form/input-control';
import { isWriteMode, ViewMode } from '@/lib/helpers';
import { Box } from '@mui/material';
import { ConnectorModel } from '@/lib/models/connector/connector.model';

interface Props {
  connector: ConnectorModel;
  formHandle: FormHandle<ConnectorModel>;
  mode: ViewMode;
}

const VertexAIConnector: FC<Props> = ({ formHandle, mode, connector }) => {
  const inWriteMode = isWriteMode(mode);
  const isNew = !connector.id;

  if (!inWriteMode) {
    return null;
  }

  return (
    <Box>
      <InputControl
        name="config.serviceAccountJson"
        type="textarea"
        label="Service Account JSON"
        formHandle={formHandle}
        required={isNew}
        updateOnly={!isNew}
        rows={6}
      />
    </Box>
  );
};

export default VertexAIConnector;
